// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nmain {\r\n padding-top: var(--menu-pad-wide-a);\n}\nform {\r\n  margin: auto;\r\n  width: 80vw;\n}\nfieldset {\r\n    width: 5em;\r\n    padding: 1em;\n}\r\n", ""]);
// Exports
module.exports = exports;
